import styled from 'styled-components';

export const FooterContainer = styled.footer`
  height: 200px;
  background-color: var(--primary);
  margin-top: 50px;
`;

export const FooterContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  img {
    height: 50px;
    width: 50px;
    margin: 0 10px;
    margin-bottom: 10px;
  }
`;
